import * as Yup from 'yup';

export const customerInvitationSignUpSchema = Yup.object().shape({
  password: Yup.string().min(6).required('Required'),
  password_confirmation: Yup.string()
    .required('Required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});